'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactIntl = require('react-intl');

var _searchBar = require('../../../search-bar');

var _headHelmet = require('../../../head-helmet');

var _searchBarTabs = require('../actions/search-bar-tabs');

var _searchBarTabs2 = _interopRequireDefault(_searchBarTabs);

var _weveGotYouCovered = require('../actions/weve-got-you-covered');

var _weveGotYouCovered2 = _interopRequireDefault(_weveGotYouCovered);

var _blogBanner = require('../actions/blog-banner');

var _blogBanner2 = _interopRequireDefault(_blogBanner);

var _landingPages = require('../actions/landing-pages');

var _landingPages2 = _interopRequireDefault(_landingPages);

var _reviewCarousel = require('../actions/review-carousel');

var _reviewCarousel2 = _interopRequireDefault(_reviewCarousel);

var _infoModals = require('../actions/info-modals');

var _page = require('../actions/page');

var _reduxSimpleAuth = require('redux-simple-auth');

var _dropdowns = require('../transformers/dropdowns');

var _transformSearchKeywordItemsForDropdown = require('../../../../src/client/utils/transformers/transformSearchKeywordItemsForDropdown');

var _transformListingsForExpandedDropdown = require('../../../../src/client/utils/transformers/transformListingsForExpandedDropdown');

var _doctifyUtils = require('doctify-utils');

var _doctifyModals = require('../../../doctify-modals');

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _loaders = require('../utils/loaders');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _modalStyles = require('../../src/styles/modal-styles.scss');

var _modalStyles2 = _interopRequireDefault(_modalStyles);

var _reactPlacesAutocomplete = require('react-places-autocomplete');

var _searchPage = require('../../../search-page');

var _constants = require('../../../../src/client/utils/constants');

var _showSearchInputRequiredMessage = require('../../../../src/client/utils/show-search-input-required-message');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_infoModalsActionsType = require('../actions/info-modals').babelPluginFlowReactPropTypes_proptype_infoModalsActionsType || require('react').PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_pageActionsType = require('../actions/page').babelPluginFlowReactPropTypes_proptype_pageActionsType || require('react').PropTypes.any;
/**
 loaders
 **/


var babelPluginFlowReactPropTypes_proptype_infoModalsState = require('../reducers/info-modals').babelPluginFlowReactPropTypes_proptype_infoModalsState || require('react').PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_pageStateType = require('../reducers/page').babelPluginFlowReactPropTypes_proptype_pageStateType || require('react').PropTypes.any;

var homePageLoader = new _doctifyUtils.PageLoader(_loaders.loaders);
var globalActions = _doctifyGlobalRedux2.default.globalActions;

var AutocompleteActions = globalActions.AutocompleteActions;
var SearchTermsActions = globalActions.SearchTermsActions;
var CreateReviewModalActions = globalActions.CreateReviewModalActions;
var ListingsActions = globalActions.ListingsActions;
var TopNavActions = globalActions.TopNavActions;
var MobileSearchMenuActions = globalActions.MobileSearchMenuActions;
var AppActions = globalActions.AppActions;

var MIN_AUTOCOMPLETE_LENGTH = 3;

var locale = 'en';
var messages = require('../../src/lang/' + locale + '.json');
var localeData = require('react-intl/locale-data/' + locale);

var appStoreBadge = require('../../src/images/app-store-badge.svg');
var googlePlayBadge = require('../../src/images/google-play-badge.png');

(0, _reactIntl.addLocaleData)(localeData);

var InfoItem = function InfoItem(props) {
  var title = props.title,
      text = props.text,
      onClick = props.onClick,
      linkTitle = props.linkTitle,
      linkHref = props.linkHref;


  return _react2.default.createElement(
    'div',
    { className: _style2.default['info-item'] },
    _react2.default.createElement(
      'h3',
      { className: _style2.default['info-item__title'] },
      title
    ),
    _react2.default.createElement('p', {
      className: _style2.default['info-item__text'],
      dangerouslySetInnerHTML: { __html: text }
    }),
    _react2.default.createElement(
      'p',
      { className: _style2.default['info-item__link-wrapper'] },
      linkHref && _react2.default.createElement(
        'a',
        {
          href: linkHref,
          className: _style2.default['info-item__link'],
          target: "_blank",
          rel: "nofollow noopener"
        },
        linkTitle
      ) || _react2.default.createElement(
        'span',
        {
          onClick: onClick,
          className: _style2.default['info-item__link']
        },
        linkTitle
      )
    )
  );
};

InfoItem.propTypes = {
  title: require('react').PropTypes.string.isRequired,
  text: require('react').PropTypes.string.isRequired,
  onClick: require('react').PropTypes.func,
  linkTitle: require('react').PropTypes.string.isRequired,
  linkHref: require('react').PropTypes.string
};

var HomePage = function (_React$Component) {
  (0, _inherits3.default)(HomePage, _React$Component);

  function HomePage(props) {
    (0, _classCallCheck3.default)(this, HomePage);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    var searchBarHolder = null;
    _this.searchBarHolder = searchBarHolder;
    return _this;
  }

  HomePage.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    var scrollElem = this.searchBarHolder;
    var offsetTop = 0;

    while (scrollElem) {
      offsetTop += scrollElem.offsetTop;
      scrollElem = scrollElem.offsetParent;
    }

    props.pageActions.updateSearchBarHolderOffset(offsetTop);
  };

  HomePage.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    (0, _doctifyUtils.execClientSideOnly)(props.init, [props]);

    var autocompleteSearchItems = props.autocomplete.directory && props.searchTerms.searchText && (0, _transformSearchKeywordItemsForDropdown.transformSearchKeywordItemsForDropdown)(props.listings, props.autocomplete.directory) || (0, _transformListingsForExpandedDropdown.transformListingsForExpandedDropdown)(props.listings, _constants.requiredTopLevelSpecialtiesNames);
    var isSpecialtiesAvailable = autocompleteSearchItems.some(function (item) {
      return item.type === 'specialty' || item.keyword_type === 'specialty';
    });

    var searchBarProps = (0, _extends3.default)({
      className: 'col-md-12',
      pageName: 'home',
      doSearch: function doSearch() {
        var search = function search() {
          var locationInputField = props.searchBarTabs.locationInputField;
          var locationItems = props.autocomplete.location;
          var selectedLocation = props.searchTerms.selectedSearchLocation;
          var newSearchTerms = {};
          if (locationInputField && !selectedLocation) {
            if (locationItems && locationItems.length > 0) {
              props.autocompleteActions.clearLocationNearMe();
              props.searchTermsActions.locationSelected(locationItems[0]);
              newSearchTerms.selectedSearchLocation = locationItems[0];

              _reactRouter.browserHistory.push(buildSearchQueryString(newSearchTerms));
            } else {
              _reactRouter.browserHistory.push(buildSearchQueryString());
            }
          } else {
            _reactRouter.browserHistory.push(buildSearchQueryString());
          }
        };

        if (!props.searchTerms.selectedSearchInsurer) {
          props.page.insurersDropdownElem && props.page.insurersDropdownElem.openDropdown();
        } else if (props.searchTerms.searchText && (!props.searchTerms.selectedSearchKeyword || props.searchTerms.selectedSearchKeyword.name !== props.searchTerms.searchText)) {
          (0, _showSearchInputRequiredMessage.showSearchInputRequiredMessage)(props.page.searchItemDropdownElem.inputField, isSpecialtiesAvailable);
        } else {
          props.pageActions.updateInsurersDropdownElem(null);
          props.pageActions.updateSearchItemDropdownElem(null);
          search();
        }
      },
      showInsurer: true,
      showLocation: true,
      locationPlaceholder: props.autocomplete.usingNearMe && !props.autocomplete.findingLocation && 'Near me' || props.autocomplete.findingLocation && 'Locating...' || null
    }, props.searchBarTabs, props.searchBarTabsActions, {

      page: props.page,
      pageActions: props.pageActions,
      listings: props.listings,

      autocompleteSearchItems: autocompleteSearchItems,
      autocompleteLocationItems: props.autocomplete.location,
      insurers: (0, _dropdowns.transformDropdownInsurer)(props.listings.insurers),

      onSearchTextChanged: props.getDirectoryAutocomplete,
      onLocationTextChanged: props.getLocationAutocomplete,

      onInsurerSelected: function onInsurerSelected(insurer) {
        props.searchTermsActions.insurerSelected(insurer);
        (0, _doctifyUtils.fireGTMevent)('search_bar_ba_insurance', insurer.name);
      },
      onLocationSelected: function onLocationSelected(location) {
        props.searchTermsActions.locationSelected(location);
        (0, _doctifyUtils.fireGTMevent)('search_bar_ba_location', location.description);
      },
      onKeywordSelected: function onKeywordSelected(keyword) {
        if (keyword.type === 'specialist') {
          _reactRouter.browserHistory.push('/specialist/' + keyword.uri_id);
        } else if (keyword.type === 'practice') {
          _reactRouter.browserHistory.push('/practice/' + keyword.uri_id);
        } else {
          props.searchTermsActions.searchTextChanged(keyword.name);
          props.searchTermsActions.keywordSelected(keyword);
        }
        (0, _doctifyUtils.fireGTMevent)('search_bar_ba_specialty', keyword.name);
      },

      selectedSearchTerm: props.searchTerms.selectedSearchKeyword && props.searchTerms.selectedSearchKeyword.type !== 'scan' && props.searchTerms.selectedSearchKeyword.type !== 'healthCheck' ? props.searchTerms.selectedSearchKeyword : undefined,
      selectedLocation: props.searchTerms.selectedSearchLocation,
      selectedInsurer: props.searchTerms.selectedSearchInsurer,

      usingNearMe: props.autocomplete.usingNearMe,
      findingLocation: props.autocomplete.findingLocation,
      getLocationNearMe: props.getLocationNearMe,
      clearLocationNearMe: props.clearLocationNearMe,

      showExpandedDropdown: true,
      scrollOffset: props.page.searchBarHolderOffset - props.app.headerHeight,
      autocompleteSearchPlaceHolder: 'Type in a speciality, condition, procedure, name...'
    });

    var buildSearchQueryString = function buildSearchQueryString(newSearchTerms) {
      var url = '/search?';

      var searchTerms = (0, _extends3.default)({}, props.searchTerms, newSearchTerms);

      var selectedKeyword = searchTerms.selectedSearchKeyword;

      if (selectedKeyword || searchTerms.searchText) {
        url += encodeURIComponent(!selectedKeyword ? 'text' : selectedKeyword.keyword_type || selectedKeyword.type).trim() + '=' + encodeURIComponent(!selectedKeyword ? searchTerms.searchText || '' : selectedKeyword.name).trim() + '&';
      }
      url += searchTerms.selectedSearchInsurer && props.searchBarTabs.selectedTab === 'appointments' ? 'insurer=' + encodeURIComponent(searchTerms.selectedSearchInsurer.name) + '&' : '';
      url += 'sort=relevance&';
      url += 'page=1&';

      // location by name
      url += searchTerms.selectedSearchLocation && !props.autocomplete.location_search_center ? 'location=' + encodeURIComponent(searchTerms.selectedSearchLocation.name) + '&' : '';
      //location by coordinates
      if (!searchTerms.selectedSearchLocation && props.autocomplete.location_search_center) {
        url += 'search_center=' + encodeURIComponent(props.autocomplete.location_search_center.latitude) + ',' + encodeURIComponent(props.autocomplete.location_search_center.longitude) + '&';
      }

      //default location
      if (!searchTerms.selectedSearchLocation && !props.autocomplete.location_search_center) {
        url += 'location=' + encodeURIComponent('London, UK') + '&';
      }

      var network = selectedKeyword && selectedKeyword.networks && selectedKeyword.networks[0];
      if (network) {
        url += 'network=' + network + '&';
      }

      url += 'search_radius=' + _searchPage.constants.DEFAULT_WITHIN + '&types_filter=11&search_type=' + encodeURIComponent(props.searchBarTabs.selectedTab || 'appointments');

      return url;
    };

    return _react2.default.createElement(
      _reactIntl.IntlProvider,
      { locale: locale, messages: messages },
      _react2.default.createElement(
        'div',
        { id: '' + _style2.default.HomePage },
        _react2.default.createElement(_headHelmet.HeadHelmet, {
          pageTitle: 'Doctify - find and book a specialist',
          pageContent: 'Find the best doctors and health specialists near you. Book doctor appointments online. Read verified doctor reviews by patients. Doctify is a free service.',
          pageImage: (0, _doctifyUtils.getResourcePath)('/img/logo-dark.svg'),
          pagePath: (0, _doctifyUtils.getResourcePath)('/')
        }),
        _react2.default.createElement(
          'section',
          {
            className: '' + _style2.default.videoModule,
            style: { paddingTop: props.app.headerHeight }
          },
          _react2.default.createElement(
            'div',
            {
              className: _style2.default.videoModuleContent + ' container ' + _style2.default.container,
              ref: function ref(elem) {
                return _this2.searchBarHolder = elem;
              }
            },
            _react2.default.createElement(_searchBar.SearchBar, searchBarProps)
          )
        ),
        _react2.default.createElement(
          'section',
          { className: '' + _style2.default['info-items-section'] },
          _react2.default.createElement(
            'div',
            { className: 'container ' + _style2.default.container },
            _react2.default.createElement(
              'div',
              { className: 'row ' + _style2.default['info-item-row'] },
              _react2.default.createElement(
                'div',
                { className: 'col-sm-6 col-lg-3 ' + _style2.default['info-item-container'] },
                _react2.default.createElement(InfoItem, {
                  title: 'How to use the finder',
                  text: 'Select your hospital list, add a speciality or suggested keyword and input your location. This will return consultants available in your area.',
                  linkTitle: 'Booking a consultant appointment',
                  onClick: function onClick() {
                    return props.infoModalsActions.changeUrgentAppointmentModal(true);
                  }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-6 col-lg-3 ' + _style2.default['info-item-container'] },
                _react2.default.createElement(InfoItem, {
                  title: 'See a physiotherapist quickly',
                  text: 'Would you like to access physio quickly and without a referral? Arrange a booking via our VGP App or download the app using the link below.',
                  linkTitle: 'Book physiotherapy',
                  onClick: function onClick() {
                    return props.infoModalsActions.changeGetVGPAppModal(true);
                  }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-6 col-lg-3 ' + _style2.default['info-item-container'] },
                _react2.default.createElement(InfoItem, {
                  title: 'Cancer Care',
                  text: 'Vitality members diagnosed with cancer can access dedicated support and care. For more information or to access this care, please log into member zone or call <a href="tel:03452798865">0345 279 8865</a>',
                  linkTitle: 'VitalityCare cancer support',
                  linkHref: 'https://www.vitality.co.uk/member/Login'
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-6 col-lg-3 ' + _style2.default['info-item-container'] },
                _react2.default.createElement(InfoItem, {
                  title: 'Vitality GP',
                  text: 'Access leading digital GP services through your Vitality Private Medical Insurance plan',
                  linkTitle: 'Get VGP',
                  onClick: function onClick() {
                    return props.infoModalsActions.changeGetVGPAppModal(true);
                  }
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'button',
          { className: '' + _style2.default.mobileFindSpecialistButton,
            onClick: function onClick() {
              props.openMobileSearchMenu();
            } },
          _react2.default.createElement('i', { className: 'ion-ios-search' }),
          'Find a specialist'
        ),
        props.infoModals.urgentAppointmentModal && _react2.default.createElement(
          _doctifyModals.DoctifyModal,
          {
            closeModal: function closeModal() {
              return props.infoModalsActions.changeUrgentAppointmentModal(false);
            },
            className: _modalStyles2.default['modal-container'],
            bodyStyles: _modalStyles2.default.body,
            headerClass: _modalStyles2.default.header,
            titleClass: _modalStyles2.default.title,
            header: "Booking a consultant appointment"
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              { className: _modalStyles2.default['justified-text'] },
              'We expect our Premier consultants to get back to you as quickly as possible \u2013 usually on the same day but certainly no later than the end of the next working day. Other consultants may take longer. We and our partners monitor delayed responses and prompt specialists at regular intervals to ensure our members are given the quality service that we expect.'
            ),
            _react2.default.createElement(
              'p',
              { className: _modalStyles2.default['justified-text'] },
              'If you need to confirm an appointment more quickly, consultants\u2019 contact details are available for you to contact them directly. Please note, however, that emergency treatment or treatment requiring urgent admission is not covered by Vitality Health insurance policies (similar to other UK private medical insurance policies).'
            ),
            _react2.default.createElement(
              'div',
              { className: _modalStyles2.default['button-container'] },
              _react2.default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return props.infoModalsActions.changeUrgentAppointmentModal(false);
                  },
                  className: 'btn ' + _modalStyles2.default['btn-primary'] },
                'close'
              )
            )
          )
        ),
        props.infoModals.accessPhysioModal && _react2.default.createElement(
          _doctifyModals.DoctifyModal,
          {
            closeModal: function closeModal() {
              return props.infoModalsActions.changeAccessPhysioModal(false);
            },
            className: _modalStyles2.default['modal-container'],
            bodyStyles: _modalStyles2.default.body,
            headerClass: _modalStyles2.default.header,
            titleClass: _modalStyles2.default.title,
            header: "Title"
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
            ),
            _react2.default.createElement(
              'div',
              { className: _modalStyles2.default['button-container'] },
              _react2.default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return props.infoModalsActions.changeAccessPhysioModal(false);
                  },
                  className: 'btn ' + _modalStyles2.default['btn-primary'] },
                'close'
              )
            )
          )
        ),
        props.infoModals.getVGPAppModal && _react2.default.createElement(
          _doctifyModals.DoctifyModal,
          {
            closeModal: function closeModal() {
              return props.infoModalsActions.changeGetVGPAppModal(false);
            },
            className: _modalStyles2.default['modal-container'],
            bodyStyles: _modalStyles2.default.body,
            headerClass: _modalStyles2.default.header,
            titleClass: _modalStyles2.default.title,
            header: "Arrange a booking through our VGP App"
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'If you have these benefits included on your plan, you can self-refer to our Priority Physiotherapy Network via your VGP app. If you don\'t have the app, download it now.'
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default['badges-container'] },
              _react2.default.createElement(
                'a',
                { href: 'https://itunes.apple.com/gb/app/vitality-gp/id1334650211?mt=8', rel: 'noreferrer noopener', target: '_blank' },
                _react2.default.createElement('img', { src: appStoreBadge, alt: 'Download on the App Store' })
              ),
              _react2.default.createElement(
                'a',
                { href: 'https://play.google.com/store/apps/details?id=com.vitality.vitalitygp&hl=en_GB', rel: 'noreferrer noopener', target: '_blank' },
                _react2.default.createElement('img', { src: googlePlayBadge, alt: 'Get it on Google Play' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _modalStyles2.default['button-container'] },
              _react2.default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return props.infoModalsActions.changeGetVGPAppModal(false);
                  },
                  className: 'btn ' + _modalStyles2.default['btn-primary'] },
                'close'
              )
            )
          )
        ),
        props.infoModals.healthInfoModal && _react2.default.createElement(
          _doctifyModals.DoctifyModal,
          {
            closeModal: function closeModal() {
              return props.infoModalsActions.changeHealthInfoModal(false);
            },
            className: _modalStyles2.default['modal-container'],
            bodyStyles: _modalStyles2.default.body,
            headerClass: _modalStyles2.default.header,
            titleClass: _modalStyles2.default.title,
            header: "Title"
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
            ),
            _react2.default.createElement(
              'div',
              { className: _modalStyles2.default['button-container'] },
              _react2.default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return props.infoModalsActions.changeHealthInfoModal(false);
                  },
                  className: 'btn ' + _modalStyles2.default['btn-primary'] },
                'close'
              )
            )
          )
        )
      )
    );
  };

  return HomePage;
}(_react2.default.Component);

HomePage.displayName = 'HomePage';

HomePage.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    searchBarTabs: state.home.searchBarTabs,
    weveGotYouCovered: state.home.weveGotYouCovered,
    blogBanner: state.home.blogBanner,
    landingPages: state.home.landingPages,
    reviewCarousel: state.home.reviewCarousel,
    searchTerms: state.global.searchTerms,
    autocomplete: state.global.autocomplete,
    listings: state.global.listings,
    createReviewModal: state.global.createReviewModal,
    topNav: state.global.topNav,
    mobileSearchMenu: state.global.mobileSearchMenu,
    app: state.global.app,
    session: (0, _reduxSimpleAuth.getSessionData)(state),
    isAuthenticated: (0, _reduxSimpleAuth.getIsAuthenticated)(state),
    infoModals: state.home.infoModals,
    page: state.home.page
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sessionActions: (0, _redux.bindActionCreators)({ invalidateSession: _reduxSimpleAuth.invalidateSession }, dispatch),
    searchBarTabsActions: (0, _redux.bindActionCreators)(_searchBarTabs2.default, dispatch),
    searchTermsActions: (0, _redux.bindActionCreators)(SearchTermsActions, dispatch),
    weveGotYouCoveredActions: (0, _redux.bindActionCreators)(_weveGotYouCovered2.default, dispatch),
    blogBannerActions: (0, _redux.bindActionCreators)(_blogBanner2.default, dispatch),
    landingPagesActions: (0, _redux.bindActionCreators)(_landingPages2.default, dispatch),
    reviewModalActions: (0, _redux.bindActionCreators)(CreateReviewModalActions, dispatch),
    autocompleteActions: (0, _redux.bindActionCreators)(AutocompleteActions, dispatch),
    listingsActions: (0, _redux.bindActionCreators)(ListingsActions, dispatch),
    reviewCarouselActions: (0, _redux.bindActionCreators)(_reviewCarousel2.default, dispatch),
    topNavActions: (0, _redux.bindActionCreators)(TopNavActions, dispatch),
    mobileSearchMenuActions: (0, _redux.bindActionCreators)(MobileSearchMenuActions, dispatch),
    infoModalsActions: (0, _redux.bindActionCreators)(_infoModals.infoModalsActions, dispatch),
    pageActions: (0, _redux.bindActionCreators)(_page.pageActions, dispatch),
    init: function init(props) {
      homePageLoader.runOnce(dispatch, props);
      if (props.app.canScrollToTop) {
        (0, _doctifyUtils.scrollToTop)(true);
        dispatch(AppActions.canScrollToTop(false));
      }
    },
    openMobileSearchMenu: function openMobileSearchMenu() {
      dispatch(MobileSearchMenuActions.openMobileSearchMenu());
    },
    getScansLocationAutocomplete: function getScansLocationAutocomplete(filter) {
      if (filter.trim().length > 1) {
        dispatch(AutocompleteActions.getLocationAutocomplete(filter));
      } else {
        dispatch(AutocompleteActions.clearLocationAutocomplete());
      }
      dispatch(_searchBarTabs2.default.openScansLocationDropdown());
    },
    getHealthChecksLocationAutocomplete: function getHealthChecksLocationAutocomplete(filter) {
      if (filter.trim().length > 1) {
        dispatch(AutocompleteActions.getLocationAutocomplete(filter));
      } else {
        dispatch(AutocompleteActions.clearLocationAutocomplete());
      }
      dispatch(_searchBarTabs2.default.openHealthChecksLocationDropdown());
    },
    getLocationAutocomplete: function getLocationAutocomplete(filter) {
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getLocationAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearLocationAutocomplete());
      }
      dispatch(_searchBarTabs2.default.openAppointmentsLocationDropdown());
    },
    mobileSearchSelectKeyword: function mobileSearchSelectKeyword(keyword) {
      dispatch(TopNavActions.mobileSearchSelectRefineCategoryOption(keyword));
      dispatch(AutocompleteActions.clearDirectoryAutocomplete());
    },
    getMobileKeywordAutocomplete: function getMobileKeywordAutocomplete(filter) {
      dispatch(SearchTermsActions.searchTextChanged(filter));
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getDirectoryAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearDirectoryAutocomplete());
      }
    },
    getMobileHealthCheckAutocomplete: function getMobileHealthCheckAutocomplete(filter) {
      dispatch(SearchTermsActions.searchTextChanged(filter));
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getHealthChecksAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearHealthChecksAutocomplete());
      }
    },
    getMobileScanAutocomplete: function getMobileScanAutocomplete(filter) {
      dispatch(SearchTermsActions.searchTextChanged(filter));
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getScansAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearScansAutocomplete());
      }
    },
    getMobileLocationAutocomplete: function getMobileLocationAutocomplete(filter) {
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getLocationAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearLocationAutocomplete());
      }
    },
    getLocationNearMe: function getLocationNearMe() {
      return new _promise2.default(function (resolve, reject) {
        dispatch(AutocompleteActions.getLocationNearMe()).then(function () {
          resolve();
        }).catch(function () {
          reject();
        });
      });
    },
    clearLocationNearMe: function clearLocationNearMe() {
      dispatch(AutocompleteActions.clearLocationNearMe());
    },
    getDirectoryAutocomplete: function getDirectoryAutocomplete(text) {
      dispatch(SearchTermsActions.searchTextChanged(text));
      if (text.length >= MIN_AUTOCOMPLETE_LENGTH) {
        dispatch(AutocompleteActions.getDirectoryAutocomplete(text));
      } else {
        dispatch(AutocompleteActions.clearDirectoryAutocomplete());
      }
      dispatch(_searchBarTabs2.default.openAppointmentsSearchDropdown());
    },
    getHealthChecksAutocomplete: function getHealthChecksAutocomplete(text) {
      dispatch(SearchTermsActions.searchTextChanged(text));
      if (text.length >= MIN_AUTOCOMPLETE_LENGTH) {
        dispatch(AutocompleteActions.getHealthChecksAutocomplete(text));
      } else {
        dispatch(AutocompleteActions.clearHealthChecksAutocomplete());
      }
      dispatch(_searchBarTabs2.default.openHealthChecksSearchDropdown());
    },
    getScansAutocomplete: function getScansAutocomplete(text) {
      dispatch(SearchTermsActions.searchTextChanged(text));
      if (text.length >= MIN_AUTOCOMPLETE_LENGTH) {
        dispatch(AutocompleteActions.getScansAutocomplete(text));
      } else {
        dispatch(AutocompleteActions.clearScansAutocomplete());
      }
      dispatch(_searchBarTabs2.default.openScansSearchDropdown());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HomePage);


// WEBPACK FOOTER //
// ./components/home-page/lib/components/home-page.js